<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-5 col-xs-12">
        @if (title()) {
          <app-title [titles]="[title()]" class="title"></app-title>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-lg-9 col-xs-12 first">
        @if (items()[0]; as item) {
          <div>
            <div class="row">
              @if (item.title) {
                <app-title [titles]="[item.title]" class="col-lg-12 col-xs-12"></app-title>
              }
            </div>
            @if (item.items) {
              <div class="row">
                @for (
                  split of item.items
                    | splitArrayBy: (this.breakpoints() === "mobile" ? item.items.length / 2 : item.items.length / 3);
                  track split
                ) {
                  <ul class="list col-lg-4 col-xs-6">
                    @for (el of split; track el) {
                      <li class="list-item">
                        <a [routerLink]="el.url">{{ el.label }}</a>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </div>
        }
      </div>
      <div class="col-lg-3 col-xs-12 last">
        @if (items()[1]; as item) {
          <div>
            <div class="row">
              @if (item.title) {
                <app-title [titles]="[item.title]" class="col-lg-12 col-xs-12"></app-title>
              }
            </div>
            <div class="row">
              <ul class="list col-lg-4 col-xs-6">
                @for (el of item.items; track el) {
                  <li class="list-item">
                    <a [routerLink]="el.url">{{ el.label }}</a>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
